import { render, staticRenderFns } from "./LightUpEffect.vue?vue&type=template&id=77fd7167&scoped=true"
import script from "./LightUpEffect.vue?vue&type=script&lang=js"
export * from "./LightUpEffect.vue?vue&type=script&lang=js"
import style0 from "./LightUpEffect.vue?vue&type=style&index=0&id=77fd7167&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fd7167",
  null
  
)

export default component.exports